import * as React from "react";

import { ExtendedFTNode } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { ClientWizardStateStore } from "stores/wizard/ClientWizardStateStore";

import { HeroImage } from "components/shared/StorefrontWizard/HeroImage/HeroImage";
import {
  TabbedWizardCard,
  WizardRegionType,
} from "components/shared/StorefrontWizard/TabbedWizardCard/TabbedWizardCard";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkSubheading } from "uitk-react-text";

export interface WizardHeroProps {
  wizardLOBs: ExtendedFTNode[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
  heroImageFigureClassNames: string;
  heroImageSrc: string;
  heroImageColor?: string;
  wizardState: ClientWizardStateStore;
  cdgTreatment?: boolean;
  aboveOtherFormChildren?: React.ReactElement[];
  belowOtherFormChildren?: React.ReactElement[];
  heading?: string;
  subHeading?: string;
}

export const WizardHero: React.FC<WizardHeroProps> = ({
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
  heroImageFigureClassNames,
  heroImageSrc,
  heroImageColor,
  wizardState,
  aboveOtherFormChildren,
  belowOtherFormChildren,
  cdgTreatment,
  heading,
  subHeading,
}) => {
  const headingElement = (isMobile: boolean) => (
    <>
      <UitkSpacing
        className="SimpleContainer cdgHeading"
        padding={{ inline: "six", blockstart: "six", small: { blockend: "six" }, medium: { blockend: "unset" } }}
      >
        <div>
          <UitkHeading className="cdgHeadingText" tag="h1" size={cdgTreatment && isMobile ? 4 : 2}>
            {heading}
          </UitkHeading>
          {subHeading && (
            <UitkSubheading className="cdgHeadingText" tag="h2">
              {subHeading}
            </UitkSubheading>
          )}
        </div>
      </UitkSpacing>
    </>
  );

  const customStyle = heroImageColor ? { backgroundColor: heroImageColor } : undefined;

  return (
    <div style={customStyle}>
      <HeroImage className={heroImageFigureClassNames} src={heroImageSrc} alt="" context={context}>
        {cdgTreatment && <UitkScrim type={UitkScrimType.OVERLAY} />}
        {heading && (
          <Viewport>
            <ViewSmall>{headingElement(true)}</ViewSmall>
            <ViewMedium>{headingElement(false)}</ViewMedium>
          </Viewport>
        )}

        {aboveOtherFormChildren}
        <LobQueryRouter lobs={wizardLOBs} />
        <TabbedWizardCard
          context={context}
          wizardFormChildren={wizardFormChildren}
          wizardState={wizardState}
          wrappingClassNames={`${
            heading ? "all-t-padding-six" : "all-t-padding-twelve"
          } all-x-padding-six s-x-padding-zero s-t-padding-zero SimpleContainer`}
          tabGroupClassNames="formAlignedTabs all-x-padding-six"
          wizardFormClassNames="wizardOverHeroImage all-x-padding-six"
          trackOnChangeTab={trackOnChangeTab}
          wizardRegionType={WizardRegionType.BEX}
        />
        {belowOtherFormChildren}
      </HeroImage>
    </div>
  );
};
